import React, { ReactElement } from 'react';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { WarningIcon } from 'components/shared';

const SessionTimeoutPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <WarningIcon dataQa='verify-session-timeout-warning-icon' />
                <ContainerLayout.Header.Title titleDataQa="verify-session-timeout-title" title={translate('Please start again')} />
            </ContainerLayout.Header>

            <ContainerLayout.InnerContent dataQa="verify-session-timeout-content">
                <p>{translate('For your security, we closed this unattended session.')}</p>
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default SessionTimeoutPage;
